import './About.css';
import TopBar from "../../common/TopBar";
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { parseAuthToken } from '../../common/TokenUtil';

export default function About() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const authToken = parseAuthToken();
  const appVersion = authToken ? authToken.app_version : '1.0.0';

  const topHeader = {
    title: t('aboutPage.title'),
    leftIcon: "/images/totp/ui/left.png",
  }

  const handleGoToList = () => {
    navigate('/vtotp/otp-list')
  }

  return (
    <div className="page-wrapper">
      <TopBar topHeader={topHeader} onLeftClick={handleGoToList}/>
      <div className="page-content">
      <div className="about-container">
        {/* Header */}
        <div className="about-header">
          <div className="about-icon">
            <img src={`${process.env.PUBLIC_URL}/images/totp/ui/ic_vanilla_totp_round.png`} alt="Vanilla TOTP" />
          </div>
          <div className="about-app-info">
            <h1>Vanilla TOTP</h1>
            <span className="version">version {appVersion}</span>
          </div>
        </div>

        {/* This App */}
        <section className="about-section">
          <p className="about-intro">
            {t('aboutPage.intro')}
          </p>
        </section>

        {/* 2FA Section */}
        <section className="about-section">
          <h2>{t('aboutPage.twoFaTitle')}</h2>
          <p>{t('aboutPage.twoFaText1')}</p>
          <p>{t('aboutPage.twoFaText2')}</p>
        </section>

        {/* TOTP Section */}
        <section className="about-section">
          <h2>{t('aboutPage.totpTitle')}</h2>
          <p>{t('aboutPage.totpText1')}</p>
          <p dangerouslySetInnerHTML={{ __html: t('aboutPage.totpText2') }}></p>
        </section>


        {/* Account Icon Credits */}
        <section className="about-section">
          <h2>Account Icon</h2>
          <p className="credit-text">Icon made by <a href="https://www.flaticon.com/authors/pixel-perfect" target="_blank" rel="noopener noreferrer">Pixel perfect</a> from <a href="https://www.flaticon.com" target="_blank" rel="noopener noreferrer">www.flaticon.com</a></p>
          <p className="credit-text">Icon made by <a href="https://www.flaticon.com/authors/freepik" target="_blank" rel="noopener noreferrer">freepik</a> from <a href="https://www.flaticon.com" target="_blank" rel="noopener noreferrer">www.flaticon.com</a></p>
          <p className="credit-text">Icon made by <a href="https://www.flaticon.com/free-icons/menu" title="menu icons">Izwar Muis</a> from <a href="https://www.flaticon.com" target="_blank" rel="noopener noreferrer">www.flaticon.com</a></p>
          <p className="credit-text">Icon made by <a href="https://www.flaticon.com/free-icons/chat-app" title="chat app icons">Bahu Icons</a> from <a href="https://www.flaticon.com" target="_blank" rel="noopener noreferrer">www.flaticon.com</a></p>
        </section>

        {/* Developer Section */}
        <section className="about-section">
          <h2>{t('aboutPage.developerTitle')}</h2>
          <div className="developer-links">
            {/* <div className="developer-link">
              <a href="https://vanillaimpl.netlify.app/" target="_blank" rel="noopener noreferrer">{t('aboutPage.developerWebsite')}</a>
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/ic_about_developer.png`} alt="Developer" />
            </div> */}
            <div className="developer-link">
              <a href="https://twitter.com/vanillaimpl" target="_blank" rel="noopener noreferrer">{t('aboutPage.developerSns')}</a>
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/twitter.png`} alt="Twitter" />
            </div>
          </div>
        </section>



        {/* What is Vanilla Section */}
        <section className="about-section">
          <h2>{t('aboutPage.whatIsVanillaTitle')}</h2>
          <p>{t('aboutPage.whatIsVanillaText1')}</p>
          <p>{t('aboutPage.whatIsVanillaText2')}</p>
        </section>





        {/* Vanilla Think Section */}
        <section className="think-section rounded-box">
          <h2>{t('vanillaThink.title')}</h2>

          <div className="think-item left">
            <div className="think-icon strawberry"></div>
            <p>{t('vanillaThink.msg1')}</p>
          </div>

          <div className="think-item right">
            <p>{t('vanillaThink.msg2')}</p>
            <div className="think-icon vanilla"></div>
          </div>

          <div className="think-item right">
            <p>{t('vanillaThink.msg3')}</p>
            <div className="think-icon vanilla"></div>
          </div>

          <div className="think-item left">
            <div className="think-icon choco"></div>
            <p>{t('vanillaThink.msg4')}</p>
          </div>

          <div className="think-item right">
            <p>{t('vanillaThink.msg5')}</p>
            <div className="think-icon vanilla"></div>
          </div>

          <div className="think-item right">
            <p>{t('vanillaThink.msg6')}</p>
            <div className="think-icon vanilla"></div>
          </div>

          <div className="think-item right">
            <p>{t('vanillaThink.msg7')}</p>
            <div className="think-icon vanilla"></div>
          </div>

          <div className="think-item right">
            <p>{t('vanillaThink.msg8')}</p>
            <div className="think-icon vanilla"></div>
          </div>

          <div className="think-item left">
            <div className="think-icon strawberry"></div>
            <p>{t('vanillaThink.msg9')}</p>
          </div>

          <div className="think-item right">
            <p>{t('vanillaThink.msg10')}</p>
            <div className="think-icon vanilla"></div>
          </div>
        </section>

        {/* Flavor Selection */}
        <div className="flavor-selection">
          <span>What is your </span>
          <div className="flavor-circles">
            <div className="flavor-circle choco"></div>
            <div className="flavor-circle vanilla"></div>
            <div className="flavor-circle strawberry"></div>
          </div>
        </div>

        {/* <div className="about-footer"></div> */}
      </div>
      </div>
    </div>
  )
}
